import { BottomPlate as Component } from './BottomPlate';

import { depositBannerState } from '../../states';

export const BottomPlate = depositBannerState(Component);
